var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageWithSidebar',[_c('div',{staticClass:"gift-up-target",attrs:{"data-site-id":"408589aa-884c-4100-bf97-94da35cf3ce7","data-platform":"Other"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }